export default {
  intro: {
    default: 'Inserisci i dati della persona che firma il contratto.',
    gbr: 'Inserisci i dati del socio che firma il contratto.',
    gmbh: "Inserisci i dati del titolare o dell'amministratore delegato che firma il contratto.",
  },
  sections: {
    home_address: 'Indirizzo di residenza',
    home_address_help: "Dove vive questa persona, non l'indirizzo del ristorante.",
  },
  form: {
    owner_first_name: {
      label: 'Nome',
      placeholder: 'Inserisci il nome',
    },
    owner_last_name: {
      label: 'Cognome',
      placeholder: 'Inserisci il cognome',
    },
    owner_dob: {
      label: 'Data di nascita',
      placeholder: 'Data',
    },
    owner_phone_number: {
      label: 'Telefono',
    },
    owner_email: {
      label: 'Email',
      placeholder: "Inserisci l'email",
      help: "Può essere diversa dall'email con cui accedi.",
    },
    owner_id_number: {
      label: 'Numero identificativo (es. codice fiscale)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Indietro',
    next: 'Avanti',
  },
};
